export default __webpack_public_path__ + "static/media/devops.15c20fe1.jpg";